import { RelatorioReservasPdfDataResponse } from "core/features/relatorios/typings";
import { PDFLayout } from "ui/components/PDF";
import { View } from "@react-pdf/renderer";
import useRelatorioReservasPdfColumns from "./components/ItemTable/hooks/useRelatorioReservasPdfColumns";
import PDFTableTitleRow from "components/PDF/Table/TableTitleRow";
import PDFTableRow from "components/PDF/Table/TableRow";
import colors from "core/resources/theme/colors";

interface PDFRelatorioReservasProps {
  data?: RelatorioReservasPdfDataResponse;
  includeDocumentWrapper?: boolean;
}

function PDFRelatorioRelatorioReservas({
  data,
  includeDocumentWrapper = true,
}: PDFRelatorioReservasProps) {
  const columns = useRelatorioReservasPdfColumns();
  return (
    <PDFLayout
      fontSize={8}
      orientation="landscape"
      includeDocument={includeDocumentWrapper}
      assinaturas={data?.assinaturas}
      headerProps={{
        logo: data?.logo!,
        tenant: data?.nomeTenant!,
        subTitle: data?.periodo!,
        title: `Relatório de Reservas`,
        cards: [
          {
            title: "Confirmadas",
            value: `${data?.totalConfirmadas ?? 0}`,
          },
          {
            title: "Pendentes",
            value: `${data?.totalPendentes ?? 0}`,
          },
          {
            title: "Aguardando Pagamento",
            value: `${data?.totalAguardandoPagamento ?? 0}`,
          },
          {
            title: "Canceladas",
            value: `${data?.totalCanceladas ?? 0}`,
          },
        ],
      }}
      footerProps={{
        tenant: data?.nomeTenant!,
        logo: data?.logoAdm!,
        endereco1: data?.endereco1!,
        endereco2: data?.endereco2!,
      }}
    >
      <View>
        <PDFTableTitleRow columns={columns} />
      </View>
      {data?.items.map((item, index) => (
        <View
          key={item.id}
          style={{ marginBottom: index < data?.items.length - 1 ? 8 : 6 }}
        >
          <View>
            <PDFTableRow
              key={index}
              backgroundColor={index % 2 === 0 ? colors.white : colors.black100}
              item={item}
              columns={columns}
            />
          </View>
        </View>
      ))}
    </PDFLayout>
  );
}

export default PDFRelatorioRelatorioReservas;
